import { get } from 'lodash/fp'
import { IPaginationState, Selector } from '../types/common'
import { ICursoryOrder } from '../types/orders'
import { IOrdersFilter } from './ordersActions'

export const ordersSelector: Selector<ICursoryOrder[]> = get('orders.orders')
export const ordersPaginationStateSelector: Selector<IPaginationState> = get(
  'orders.paginationState',
)
export const ordersFilterSelector: Selector<IOrdersFilter> = get(
  'orders.ordersFilter',
)
export const ordersTotalSelector: Selector<number> = get('orders.total')
